export enum brightlyColors {
    brightlyBlue = '#002743',
    darkBlue = '#001221',
    brightlyGreen = '#48FF9B',
    brightlyTeal = '#017D80',
    lightTeal = '#DFEEEF',
    purple = '#3A076D',
    white = '#FFFFFF'
}